export const INDEX_URL = '/';
export const FORGOT_PASSWORD_URL = '/forgot-password';
export const NEW_PASSWORD_URL = '/new-password';
export const DASHBOARD_URL = '/dashboard';
